import { PlantCard } from './plant-card.tsx';
import { PlantsWithOverview } from '@/features/plants/hooks/queries/use-get-plants.tsx';
import { type ViewType, type SetupType } from './plants-list-view-filter-command.tsx';
import { PlantsTable } from './plants-table/plants-table.tsx';

type LayoutType = 'grid' | 'table';

type ViewFilterState = {
  view: ViewType;
  setupType: SetupType;
};

export const PlantsList = ({
  plants,
  viewFilterState,
  layout,
}: {
  plants: PlantsWithOverview[];
  viewFilterState: ViewFilterState;
  layout: LayoutType;
}) => {
  const getViewType = (plant: PlantsWithOverview) => {
    const setupPlantType = plant.technicalSpecifications.setupType;

    let viewType = 'production-only';

    if (setupPlantType === 'storage-only') {
      viewType = 'storage-only';
    }

    if (setupPlantType === 'storage-only' && viewFilterState.view === 'storage') {
      viewType = 'storage-only';
    }

    if (setupPlantType === 'production-only' && viewFilterState.view === 'production') {
      viewType = 'production-only';
    }

    if (setupPlantType === 'production-storage' && viewFilterState.view === 'storage') {
      viewType = 'storage-only';
    }

    return viewType;
  };

  if (layout === 'table') {
    return (
      <PlantsTable data={plants} isLoading={false} viewType={viewFilterState.view} />
    );
  }

  return (
    <ul className="grid grid-cols-1 gap-6 min-[1101px]:grid-cols-2 min-[1651px]:grid-cols-3">
      {plants?.map((plant) => (
        <PlantCard plant={plant} key={plant.plantId} viewType={getViewType(plant)} />
      ))}
    </ul>
  );
};
